import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/react"

export default () => (
  <StaticQuery
    query={graphql`
      query imageTechniquesquery {
        file(relativePath: { eq: "microchirurgie.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.file.childImageSharp.fluid}
        alt="Le Dr Roure utilise des techniques récentes et très peu invasives comme la microchirurgie"
        css={css`
          margin-top: 6px;
        `}
      />
    )}
  />
)
